/**
 * directive to create the tabindex attribute automatically by id.
 * requirement is that the input field has id value like "input_123"
 **/

export default function($injector) {
	let $timeout = $injector.get('$timeout');

	let directive = {
		restrict: 'A',
		link: function($scope, elem, attrs) {
			$timeout( ()=> {
				let id = elem[0].id;
				let splittet = id.split('_');
				let tabindex = parseInt(splittet[splittet.length - 1]);
				elem.attr('tabindex', tabindex);
			}, 0);
		}
	};

	return directive;
}
